import { Call, Email, Save } from "@mui/icons-material";
import { Grid, Box, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import React from "react";

import { LeadState } from "0.Mine/3.Interfaces/lead";
import { SafeArgonInput, SafeArgonButton } from "0.Mine/4.Argon/ArgonComponents";

import { FormData } from "../sharedTypes";

interface FormFieldsProps {
  formData: FormData;
  isMobile: boolean;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleSelectChange: (e: any) => void;
  handleDateChange: (date: Date | null) => void;
}

const FormFields: React.FC<FormFieldsProps> = ({
  formData,
  isMobile,
  handleInputChange,
  handleSelectChange,
  handleDateChange,
}) => {
  return (
    <Grid container spacing={isMobile ? 1 : 2}>
      <Grid item xs={12}>
        <SafeArgonInput
          type="text"
          label="Full Name"
          name="name"
          value={formData.name}
          onChange={handleInputChange}
          fullWidth
          required
          placeholder="Nome del lead"
        />
      </Grid>

      <Grid item xs={12}>
        <SafeArgonInput
          type="text"
          label="Company Name"
          name="company"
          value={formData.company}
          onChange={handleInputChange}
          fullWidth
          placeholder="Nome azienda"
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <SafeArgonInput
          type="text"
          label="Indirizzo"
          name="indirizzo"
          value={formData.address}
          onChange={handleInputChange}
          fullWidth
          placeholder="Inserisci l'indirizzo del lead"
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <SafeArgonInput
          type="text"
          label="città"
          name="city"
          value={formData.city}
          onChange={handleInputChange}
          fullWidth
          placeholder="Inserisci la citta'"
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <SafeArgonInput
          type="email"
          label="Email Address"
          name="email"
          value={formData.email}
          onChange={handleInputChange}
          fullWidth
          placeholder="example@azienda.com"
          InputProps={{
            startAdornment: <Email fontSize="small" sx={{ color: "text.secondary", mr: 1 }} />,
          }}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <SafeArgonInput
          type="tel"
          label="Phone Number"
          name="phone"
          value={formData.phone}
          onChange={handleInputChange}
          fullWidth
          placeholder="+39 (123) 456-7890"
          InputProps={{
            startAdornment: <Call fontSize="small" sx={{ color: "text.secondary", mr: 1 }} />,
          }}
        />
      </Grid>

      {/*<Grid item xs={12} sm={6}>
                <SafeArgonInput
                    type="text"
                    label="Status"
                    name="status"
                    value={formData.state}
                    onChange={handleInputChange}
                    fullWidth
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <SafeArgonInput
                    type="text"
                    label="Potential Value"
                    name="value"
                    value={formData.value}
                    onChange={handleInputChange}
                    fullWidth
                    placeholder="$0.00"
                    InputProps={{
                        startAdornment: <Box component="span" sx={{ color: 'text.secondary', mr: 1 }}>$</Box>
                    }}
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <FormControl fullWidth variant="outlined">
                    <InputLabel id="lead-state-label">Lead Qualification</InputLabel>
                    <Select
                        labelId="lead-state-label"
                        id="lead-state"
                        name="state"
                        value={formData.state}
                        onChange={handleSelectChange}
                        label="Lead Qualification"
                    >
                        {leadStateOptions.map(option => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>*/}

      <Grid item xs={12}>
        <SafeArgonInput
          multiline
          rows={isMobile ? 3 : 4}
          label="Notes & Comments"
          name="notes"
          value={formData.notes}
          onChange={handleInputChange}
          fullWidth
          placeholder="Aggiung note o commenti"
        />
      </Grid>

      <Grid
        item
        xs={12}
        sx={{
          mt: isMobile ? 1 : 2,
          display: "flex",
          justifyContent: isMobile ? "center" : "flex-start",
        }}
      >
        <SafeArgonButton
          type="submit"
          color="success"
          variant="contained"
          startIcon={<Save />}
          size={isMobile ? "small" : "medium"}
          sx={{ width: isMobile ? "100%" : "auto" }}
        >
          Salva
        </SafeArgonButton>
      </Grid>
    </Grid>
  );
};

export default FormFields;
